export const pushDataLayer = (payload: Record<string, any>) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
};

const getGaClientId = (): Promise<string | null> => {
  return new Promise((resolve) => {
    if (typeof window === 'undefined') {
      resolve(null);
      return;
    }

    // 优先使用 gtag 官方 API，通过 dataLayer 里的 _ga_XXXX cookie 自动匹配当前属性
    if (typeof window.gtag === 'function') {
      // 从 cookie 名中找到所有 _ga_XXXX 对应的 measurement id
      const cookies = document.cookie.split(';').map(c => c.trim());
      const gaPropertyCookie = cookies.find(c => /^_ga_[A-Z0-9]+/.test(c));
      if (gaPropertyCookie) {
        // _ga_XXXXXX -> G-XXXXXX
        const containerId = gaPropertyCookie.split('=')[0].replace('_ga_', 'G-');
        window.gtag('get', containerId, 'client_id', (clientId: string) => {
          console.log('[GA client_id] via gtag:', clientId);
          resolve(clientId || null);
        });
        return;
      }
    }

    // 降级：从 _ga cookie 中取域名最宽（最短 domain）的那个，即根域名的 cookie
    // document.cookie 无法区分域名，取最后一个 _ga（根域名通常排在后面）
    const cookies = document.cookie.split(';').map(c => c.trim());
    const gaCookies = cookies.filter(c => c.indexOf('_ga=') === 0);
    const last = gaCookies[gaCookies.length - 1];
    if (last) {
      // GA1.1.<client_id> 跳过前6个字符
      const id = last.substring('_ga='.length + 6) || null;
      console.log('[GA client_id] via cookie fallback:', id);
      resolve(id);
      return;
    }

    console.log('[GA client_id] not found');
    resolve(null);
  });
};

export const pushEcommerceEvent = async ({
  event,
  ecommerce,
  ...payload
}: {
  event: string;
  ecommerce: Record<string, any>;
  [key: string]: any;
}) => {
  const client_id = await getGaClientId();
  console.log(`dataLayer output for event: ${event}`, { event, ecommerce, ...payload, ...(client_id ? { client_id } : {}) });
  pushDataLayer({
    ecommerce: null,
  });
  pushDataLayer({
    event,
    ecommerce,
    ...(client_id ? { client_id } : {}),
    ...payload,
  });
};
